"use strict";

exports.__esModule = true;
exports.WindowedMean = exports.Vector2 = exports.Utils = exports.TimeKeeper = exports.StringSet = exports.PowOut = exports.Pow = exports.Pool = exports.MathUtils = exports.Interpolation = exports.IntSet = exports.DebugUtils = exports.Color = void 0;

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
var IntSet = /*#__PURE__*/function () {
  function IntSet() {
    this.array = new Array();
  }

  var _proto = IntSet.prototype;

  _proto.add = function add(value) {
    var contains = this.contains(value);
    this.array[value | 0] = value | 0;
    return !contains;
  };

  _proto.contains = function contains(value) {
    return this.array[value | 0] != undefined;
  };

  _proto.remove = function remove(value) {
    this.array[value | 0] = undefined;
  };

  _proto.clear = function clear() {
    this.array.length = 0;
  };

  return IntSet;
}();

exports.IntSet = IntSet;

var StringSet = /*#__PURE__*/function () {
  function StringSet() {
    this.entries = {};
    this.size = 0;
  }

  var _proto2 = StringSet.prototype;

  _proto2.add = function add(value) {
    var contains = this.entries[value];
    this.entries[value] = true;

    if (!contains) {
      this.size++;
      return true;
    }

    return false;
  };

  _proto2.addAll = function addAll(values) {
    var oldSize = this.size;

    for (var i = 0, n = values.length; i < n; i++) {
      this.add(values[i]);
    }

    return oldSize != this.size;
  };

  _proto2.contains = function contains(value) {
    return this.entries[value];
  };

  _proto2.clear = function clear() {
    this.entries = {};
    this.size = 0;
  };

  return StringSet;
}();

exports.StringSet = StringSet;

var Color = /*#__PURE__*/function () {
  function Color(r, g, b, a) {
    if (r === void 0) {
      r = 0;
    }

    if (g === void 0) {
      g = 0;
    }

    if (b === void 0) {
      b = 0;
    }

    if (a === void 0) {
      a = 0;
    }

    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  var _proto3 = Color.prototype;

  _proto3.set = function set(r, g, b, a) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
    return this.clamp();
  };

  _proto3.setFromColor = function setFromColor(c) {
    this.r = c.r;
    this.g = c.g;
    this.b = c.b;
    this.a = c.a;
    return this;
  };

  _proto3.setFromString = function setFromString(hex) {
    hex = hex.charAt(0) == '#' ? hex.substr(1) : hex;
    this.r = parseInt(hex.substr(0, 2), 16) / 255;
    this.g = parseInt(hex.substr(2, 2), 16) / 255;
    this.b = parseInt(hex.substr(4, 2), 16) / 255;
    this.a = hex.length != 8 ? 1 : parseInt(hex.substr(6, 2), 16) / 255;
    return this;
  };

  _proto3.add = function add(r, g, b, a) {
    this.r += r;
    this.g += g;
    this.b += b;
    this.a += a;
    return this.clamp();
  };

  _proto3.clamp = function clamp() {
    if (this.r < 0) this.r = 0;else if (this.r > 1) this.r = 1;
    if (this.g < 0) this.g = 0;else if (this.g > 1) this.g = 1;
    if (this.b < 0) this.b = 0;else if (this.b > 1) this.b = 1;
    if (this.a < 0) this.a = 0;else if (this.a > 1) this.a = 1;
    return this;
  };

  Color.rgba8888ToColor = function rgba8888ToColor(color, value) {
    color.r = ((value & 0xff000000) >>> 24) / 255;
    color.g = ((value & 0x00ff0000) >>> 16) / 255;
    color.b = ((value & 0x0000ff00) >>> 8) / 255;
    color.a = (value & 0x000000ff) / 255;
  };

  Color.rgb888ToColor = function rgb888ToColor(color, value) {
    color.r = ((value & 0x00ff0000) >>> 16) / 255;
    color.g = ((value & 0x0000ff00) >>> 8) / 255;
    color.b = (value & 0x000000ff) / 255;
  };

  Color.fromString = function fromString(hex) {
    return new Color().setFromString(hex);
  };

  return Color;
}();

exports.Color = Color;
Color.WHITE = new Color(1, 1, 1, 1);
Color.RED = new Color(1, 0, 0, 1);
Color.GREEN = new Color(0, 1, 0, 1);
Color.BLUE = new Color(0, 0, 1, 1);
Color.MAGENTA = new Color(1, 0, 1, 1);

var MathUtils = /*#__PURE__*/function () {
  function MathUtils() {}

  MathUtils.clamp = function clamp(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  };

  MathUtils.cosDeg = function cosDeg(degrees) {
    return Math.cos(degrees * MathUtils.degRad);
  };

  MathUtils.sinDeg = function sinDeg(degrees) {
    return Math.sin(degrees * MathUtils.degRad);
  };

  MathUtils.signum = function signum(value) {
    return value > 0 ? 1 : value < 0 ? -1 : 0;
  };

  MathUtils.toInt = function toInt(x) {
    return x > 0 ? Math.floor(x) : Math.ceil(x);
  };

  MathUtils.cbrt = function cbrt(x) {
    var y = Math.pow(Math.abs(x), 1 / 3);
    return x < 0 ? -y : y;
  };

  MathUtils.randomTriangular = function randomTriangular(min, max) {
    return MathUtils.randomTriangularWith(min, max, (min + max) * 0.5);
  };

  MathUtils.randomTriangularWith = function randomTriangularWith(min, max, mode) {
    var u = Math.random();
    var d = max - min;
    if (u <= (mode - min) / d) return min + Math.sqrt(u * d * (mode - min));
    return max - Math.sqrt((1 - u) * d * (max - mode));
  };

  MathUtils.isPowerOfTwo = function isPowerOfTwo(value) {
    return value && (value & value - 1) === 0;
  };

  return MathUtils;
}();

exports.MathUtils = MathUtils;
MathUtils.PI = 3.1415927;
MathUtils.PI2 = MathUtils.PI * 2;
MathUtils.radiansToDegrees = 180 / MathUtils.PI;
MathUtils.radDeg = MathUtils.radiansToDegrees;
MathUtils.degreesToRadians = MathUtils.PI / 180;
MathUtils.degRad = MathUtils.degreesToRadians;

var Interpolation = /*#__PURE__*/function () {
  function Interpolation() {}

  var _proto4 = Interpolation.prototype;

  _proto4.apply = function apply(start, end, a) {
    return start + (end - start) * this.applyInternal(a);
  };

  return Interpolation;
}();

exports.Interpolation = Interpolation;

var Pow = /*#__PURE__*/function (_Interpolation) {
  _inheritsLoose(Pow, _Interpolation);

  function Pow(power) {
    var _this;

    _this = _Interpolation.call(this) || this;
    _this.power = 2;
    _this.power = power;
    return _this;
  }

  var _proto5 = Pow.prototype;

  _proto5.applyInternal = function applyInternal(a) {
    if (a <= 0.5) return Math.pow(a * 2, this.power) / 2;
    return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
  };

  return Pow;
}(Interpolation);

exports.Pow = Pow;

var PowOut = /*#__PURE__*/function (_Pow) {
  _inheritsLoose(PowOut, _Pow);

  function PowOut(power) {
    return _Pow.call(this, power) || this;
  }

  var _proto6 = PowOut.prototype;

  _proto6.applyInternal = function applyInternal(a) {
    return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
  };

  return PowOut;
}(Pow);

exports.PowOut = PowOut;

var Utils = /*#__PURE__*/function () {
  function Utils() {}

  Utils.arrayCopy = function arrayCopy(source, sourceStart, dest, destStart, numElements) {
    for (var i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++) {
      dest[j] = source[i];
    }
  };

  Utils.arrayFill = function arrayFill(array, fromIndex, toIndex, value) {
    for (var i = fromIndex; i < toIndex; i++) {
      array[i] = value;
    }
  };

  Utils.setArraySize = function setArraySize(array, size, value) {
    if (value === void 0) {
      value = 0;
    }

    var oldSize = array.length;
    if (oldSize == size) return array;
    array.length = size;

    if (oldSize < size) {
      for (var i = oldSize; i < size; i++) {
        array[i] = value;
      }
    }

    return array;
  };

  Utils.ensureArrayCapacity = function ensureArrayCapacity(array, size, value) {
    if (value === void 0) {
      value = 0;
    }

    if (array.length >= size) return array;
    return Utils.setArraySize(array, size, value);
  };

  Utils.newArray = function newArray(size, defaultValue) {
    var array = new Array(size);

    for (var i = 0; i < size; i++) {
      array[i] = defaultValue;
    }

    return array;
  };

  Utils.newFloatArray = function newFloatArray(size) {
    if (Utils.SUPPORTS_TYPED_ARRAYS) return new Float32Array(size);else {
      var array = new Array(size);

      for (var i = 0; i < array.length; i++) {
        array[i] = 0;
      }

      return array;
    }
  };

  Utils.newShortArray = function newShortArray(size) {
    if (Utils.SUPPORTS_TYPED_ARRAYS) return new Int16Array(size);else {
      var array = new Array(size);

      for (var i = 0; i < array.length; i++) {
        array[i] = 0;
      }

      return array;
    }
  };

  Utils.toFloatArray = function toFloatArray(array) {
    return Utils.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
  };

  Utils.toSinglePrecision = function toSinglePrecision(value) {
    return Utils.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
  } // This function is used to fix WebKit 602 specific issue described at http://esotericsoftware.com/forum/iOS-10-disappearing-graphics-10109
  ;

  Utils.webkit602BugfixHelper = function webkit602BugfixHelper(alpha, blend) {};

  Utils.contains = function contains(array, element, identity) {
    if (identity === void 0) {
      identity = true;
    }

    for (var i = 0; i < array.length; i++) {
      if (array[i] == element) return true;
    }

    return false;
  };

  Utils.enumValue = function enumValue(type, name) {
    return type[name[0].toUpperCase() + name.slice(1)];
  };

  return Utils;
}();

exports.Utils = Utils;
Utils.SUPPORTS_TYPED_ARRAYS = typeof Float32Array !== "undefined";

var DebugUtils = /*#__PURE__*/function () {
  function DebugUtils() {}

  DebugUtils.logBones = function logBones(skeleton) {
    for (var i = 0; i < skeleton.bones.length; i++) {
      var bone = skeleton.bones[i];
      console.log(bone.data.name + ", " + bone.a + ", " + bone.b + ", " + bone.c + ", " + bone.d + ", " + bone.worldX + ", " + bone.worldY);
    }
  };

  return DebugUtils;
}();

exports.DebugUtils = DebugUtils;

var Pool = /*#__PURE__*/function () {
  function Pool(instantiator) {
    this.items = new Array();
    this.instantiator = instantiator;
  }

  var _proto7 = Pool.prototype;

  _proto7.obtain = function obtain() {
    return this.items.length > 0 ? this.items.pop() : this.instantiator();
  };

  _proto7.free = function free(item) {
    if (item.reset) item.reset();
    this.items.push(item);
  };

  _proto7.freeAll = function freeAll(items) {
    for (var i = 0; i < items.length; i++) {
      this.free(items[i]);
    }
  };

  _proto7.clear = function clear() {
    this.items.length = 0;
  };

  return Pool;
}();

exports.Pool = Pool;

var Vector2 = /*#__PURE__*/function () {
  function Vector2(x, y) {
    if (x === void 0) {
      x = 0;
    }

    if (y === void 0) {
      y = 0;
    }

    this.x = x;
    this.y = y;
  }

  var _proto8 = Vector2.prototype;

  _proto8.set = function set(x, y) {
    this.x = x;
    this.y = y;
    return this;
  };

  _proto8.length = function length() {
    var x = this.x;
    var y = this.y;
    return Math.sqrt(x * x + y * y);
  };

  _proto8.normalize = function normalize() {
    var len = this.length();

    if (len != 0) {
      this.x /= len;
      this.y /= len;
    }

    return this;
  };

  return Vector2;
}();

exports.Vector2 = Vector2;

var TimeKeeper = /*#__PURE__*/function () {
  function TimeKeeper() {
    this.maxDelta = 0.064;
    this.framesPerSecond = 0;
    this.delta = 0;
    this.totalTime = 0;
    this.lastTime = Date.now() / 1000;
    this.frameCount = 0;
    this.frameTime = 0;
  }

  var _proto9 = TimeKeeper.prototype;

  _proto9.update = function update() {
    var now = Date.now() / 1000;
    this.delta = now - this.lastTime;
    this.frameTime += this.delta;
    this.totalTime += this.delta;
    if (this.delta > this.maxDelta) this.delta = this.maxDelta;
    this.lastTime = now;
    this.frameCount++;

    if (this.frameTime > 1) {
      this.framesPerSecond = this.frameCount / this.frameTime;
      this.frameTime = 0;
      this.frameCount = 0;
    }
  };

  return TimeKeeper;
}();

exports.TimeKeeper = TimeKeeper;

var WindowedMean = /*#__PURE__*/function () {
  function WindowedMean(windowSize) {
    if (windowSize === void 0) {
      windowSize = 32;
    }

    this.addedValues = 0;
    this.lastValue = 0;
    this.mean = 0;
    this.dirty = true;
    this.values = new Array(windowSize);
  }

  var _proto10 = WindowedMean.prototype;

  _proto10.hasEnoughData = function hasEnoughData() {
    return this.addedValues >= this.values.length;
  };

  _proto10.addValue = function addValue(value) {
    if (this.addedValues < this.values.length) this.addedValues++;
    this.values[this.lastValue++] = value;
    if (this.lastValue > this.values.length - 1) this.lastValue = 0;
    this.dirty = true;
  };

  _proto10.getMean = function getMean() {
    if (this.hasEnoughData()) {
      if (this.dirty) {
        var mean = 0;

        for (var i = 0; i < this.values.length; i++) {
          mean += this.values[i];
        }

        this.mean = mean / this.values.length;
        this.dirty = false;
      }

      return this.mean;
    }

    return 0;
  };

  return WindowedMean;
}();

exports.WindowedMean = WindowedMean;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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